import { render, staticRenderFns } from "./agendamento_especialidade.vue?vue&type=template&id=18ad042e&scoped=true"
import script from "./agendamento_especialidade.vue?vue&type=script&lang=js"
export * from "./agendamento_especialidade.vue?vue&type=script&lang=js"
import style0 from "./agendamento_especialidade.vue?vue&type=style&index=0&id=18ad042e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ad042e",
  null
  
)

export default component.exports